var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFinances = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dollar",
    strokeWidth: 0,
    d: "M10.61 8.588c-.454-.195-.937-.344-1.415-.498-.278-.09-.543-.193-.778-.338-.461-.286-.373-.751.168-.935.153-.052.313-.069.476-.076.626-.026 1.222.063 1.789.275.282.106.375.072.47-.156.101-.242.185-.487.278-.73.062-.164-.014-.272-.213-.341-.363-.125-.736-.214-1.128-.262-.512-.061-.512-.063-.515-.463-.002-.563-.002-.563-.73-.563-.104 0-.21-.002-.315 0-.34.007-.397.054-.406.32-.005.119 0 .237-.003.358-.002.353-.005.348-.44.47-1.052.298-1.703.856-1.772 1.748-.062.79.469 1.323 1.303 1.712.515.24 1.084.38 1.63.569.212.072.415.156.592.271.524.336.428.896-.194 1.108-.332.113-.684.141-1.045.106-.557-.054-1.09-.168-1.592-.37-.295-.12-.38-.087-.481.16-.086.213-.163.43-.24.645-.102.29-.064.358.292.494.455.171.94.258 1.435.32.388.048.4.061.405.373l.004.426c.003.179.113.283.35.286.267.004.538.004.806-.001.22-.004.332-.097.332-.27 0-.193.012-.389.002-.582-.012-.197.098-.297.342-.35.562-.118 1.04-.352 1.409-.702 1.024-.966.634-2.381-.816-3.004z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFinances, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/finances.b6a197f7.svg";
export { ForwardRef as ReactComponent };